import { Fragment } from 'react'
import { ButtonPrimary, ButtonSecondary } from '../../../baseComponents/Button'
import LoaderDecider from '../../../baseComponents/LoaderDecider'
import { ModalOpenedSetTy } from '../../../baseComponents/Modal/types'
import './footer_input_table_modal_select.sass'

interface FooterInputTableModalSelectProps extends FooterRightInputTableModalButtonsProps {
    footerLeftComponents: FooterLeftInputTableModalComponentProps[]
}

const FooterInputTableModalSelect: React.FC<FooterInputTableModalSelectProps> = ({ footerLeftComponents, ...buttonProps }) => {
    const renderThis: JSX.Element[] = []
    for (const key in footerLeftComponents) {
        const element = footerLeftComponents[key]
        const pos = parseInt(key)
        renderThis.push(<FooterLeftInputTableModalComponent key={key} label={element.label}>{element.children}</FooterLeftInputTableModalComponent>)
        if (pos !== footerLeftComponents.length - 1) {
            renderThis.push(<div key={'separator' + pos} className='horizontal_separator' />)
        }
    }
    return (
        <Fragment>
            <div style={{ height: 50 }}></div>
            <div className='absolute footer_input_table_modal_select flex items-center py-10 px-30 gap-x-10 justify-end'>
                <div className='mr-auto flex items-center gap-x-20'>
                    {renderThis}
                </div>
                <FooterRightInputTableModalButtons {...buttonProps} />
            </div>
        </Fragment>
    )
}

export interface FooterLeftInputTableModalComponentProps {
    label: string
    children: React.ReactNode
}

const FooterLeftInputTableModalComponent: React.FC<FooterLeftInputTableModalComponentProps> = ({ label, children }) => {
    return (
        <div className='flex items-center'>
            <span className='regular14 mr-5'>{label}:</span>
            {children}
        </div>
    )
}

interface FooterRightInputTableModalButtonsProps {
    setOpened: ModalOpenedSetTy
    disabled?: boolean
    onAccept: () => void
    onCancel?: () => void
    textAccept: string
    textCancel: string
    loading?: boolean
}

const FooterRightInputTableModalButtons: React.FC<FooterRightInputTableModalButtonsProps> = ({ textAccept, textCancel, setOpened, disabled, onAccept, loading, onCancel }) => {
    return (
        <LoaderDecider loading={loading || false}>
            <div className='flex items-center gap-x-10'>
                <ButtonSecondary onClick={() => { onCancel?.(); setOpened(null)}}>{textCancel}</ButtonSecondary>
                <ButtonPrimary onClick={onAccept} disabled={disabled}>{textAccept}</ButtonPrimary>
            </div>
        </LoaderDecider>
    )
}


export default FooterInputTableModalSelect 